import styled from "styled-components";

// INFO: Overrides RIO UI Toolkit tabs component styles for THIS usage
export const ThreadsHistoryWrapper = styled.div`
    .tab-content {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }

    .nav-tabs .active-tab {
        color: var(--brand-primary) !important;
    }
`;